import { useState } from 'react';
import { FormControl, FormHelperText, InputLabel, Select, SelectProps } from '@mui/material';
import { Controller, Control } from 'react-hook-form';

type ControlledSelectProps = SelectProps & {
  control: Control<any, any>;
  name: string;
  required?: boolean;
  errorMessage?: string;
  helperText?: string;
};

export const ControlledSelect = ({
  name,
  label,
  control,
  defaultValue,
  children,
  errorMessage,
  helperText,
  sx,
  ...props
}: ControlledSelectProps) => {
  const [hasFocus, setHasFocus] = useState(false);
  const labelId = `${name}-label`;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, onBlur, value = '', ref }, fieldState: { error } }) => (
        <>
          <FormControl
            error={Boolean(error)}
            sx={{
              width: props.fullWidth ? '100%' : 'auto',
              '& label': {
                top: !hasFocus && !value ? '-8px' : 'initial',
              },
              ...sx,
            }}
          >
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
              labelId={labelId}
              label={label}
              onChange={onChange}
              onBlur={() => {
                setHasFocus(false);
                onBlur();
              }}
              onFocus={(event) => {
                setHasFocus(true);
                props?.onFocus && props?.onFocus(event);
              }}
              value={value}
              ref={ref}
              {...props}
            >
              {children}
            </Select>
            {error && errorMessage && (
              <FormHelperText id={`component-error-text-${name}`}>{errorMessage}</FormHelperText>
            )}
            {helperText && !(error && errorMessage) && (
              <FormHelperText id={`component-error-text-${name}`}>{helperText}</FormHelperText>
            )}
          </FormControl>
        </>
      )}
    />
  );
};
